import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Parse from 'parse'
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import Modal from './Modal'
import { BiggerText, Spinner, Heading2, PrimaryButton, TextField, NoticeText, GridRow } from './MarketingStyles';
import { withCookies, Cookies } from 'react-cookie';

import MultistepForm from '../onboarding/MultistepForm';
import checkmark from '../../images/icons/checkmark.svg'
import spinnerCircle from '../../images/icons/spinner-circle.svg'
import { inject, observer } from 'mobx-react'

import { trackEvent } from "../../utils/eventTracking"

@inject('modalStore', 'translationStore')
@observer
class RequestInformationModal extends Component {

  request = ( e, selectSub ) => {
    e.preventDefault();
    trackEvent( 'Request Information - Freischalten - Button ', 'Advertisment', 'Form Submission' )
    selectSub(1)
    const data = e.target

    if(data.honey && data.honey.value !== '') {
      console.log('bot detected');
      return
    }

    Parse.Cloud.run( 'requestMoreInformation', {
      mail: data.mail.value,
      name: data.name.value,
      phone: data.phone.value,
    }).then(() => {
      selectSub(2)
      this.props.cookies.set('hasDetailAccess', true, { path: '/' })
      // setTimeout(() => {
      //   this.props.history.push("/details-zur-plattform/#features")
      //   this.closeModal()
      // }, 2000);
    }).catch(e => selectSub(3))
  }

  closeModal = () => {
    this.props.modalStore.setState('request_information', false)
  }

  componentDidMount() {
    if(this.props.cookies.get('hasDetailAccess')) {
      this.form.selectSub(2)
    }
  }

  render() {

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    const RequestForm = ({ selectSub }) => (
      <div>
        <BiggerText>{ text('marketing_info_modal_subheadline') }</BiggerText>
        <Heading2>{ text('marketing_info_modal_headline') }</Heading2>
        <form onSubmit={ (e) => this.request(e, selectSub) }>
          <GridRow desktop="1fr 1fr" phone="1fr">
            <TextField required name="name" placeholder={ text('name') } />
            <TextField required name="phone" placeholder={ text('phone_number') } />
          </GridRow>
          <GridRow desktop="1fr">
            <TextField required name="mail" placeholder={ text('email') } type="email" />
          </GridRow>

          <TextField name="honey" style={{display: 'none'}} />

          <PrimaryButton
            style={{marginTop: 30}}
            value={ text('marketing_info_modal_button') }
          />

        </form>
        <NoticeText>{ text('marketing_info_modal_notice') }</NoticeText>
      </div>
    )

    const Loading = () => (
      <div style={{textAlign: 'center'}}>
        <Spinner src={ spinnerCircle } style={{marginBottom: 50}} />
        <Heading2>{ text('marketing_info_modal_success') }</Heading2>
      </div>
    )

    const Success = () => (
      <div style={{textAlign: 'center'}}>
        <img src={ checkmark } style={{marginBottom: 50}} />
        <BiggerText>{ text('marketing_info_modal_success_headline') }</BiggerText>
        <Heading2>{ text('marketing_info_modal_success2') }</Heading2>
        {/* <BiggerText>Sie werden in kürze weitergeleitet.<br /> Falls nicht klicken Sie <a href="/details-zur-plattform">hier</a></BiggerText> */}
        <PrimaryButton
          style={{marginTop: 50}}
          value={ text('close') }
          onClick={ this.closeModal }
        />
      </div>
    )

    const Error = () => (
      <div>Error!!!</div>
    )

    const steps = [
      {
        components: [
          () => <RequestForm />,
          () => <Loading />,
          () => <Success />,
          () => <Error />,
        ],
      }
    ]

    if(!(this.props.translationStore && this.props.translationStore.loaded)) return <div></div>

    return (
      <Modal slug="request_information">
        <MultistepForm steps={ steps } onRef={ref =>  { this.form = ref } } />
      </Modal>
    )
  }
}

export default withCookies(withRouter(RequestInformationModal))



// WEBPACK FOOTER //
// /src/components/marketing/RequestInformationModal.js